export default {"src":"/_next/static/image/public/images/ic_logo_assistant.c03c9ccc474773c836d939ddcdcadf6f.svg","height":28,"width":28};